import { FunctionComponent, useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../../context';
import { optArrItem, TabItem, Tabs, useIsNarrowViewport } from '../../../shared';
import { AppConfig } from './AppConfig';
import { Danger } from './Danger';
import { General } from './General';
import { OrgConfig } from './OrgConfig';
import { Security } from './Security';
import { Staff } from './Staff';
import { Tags } from './Tags';
import { Templates } from './Templates';

import classes from './Settings.module.scss';

enum SettingsTabType {
  GENERAL,
  TAGS,
  CATEGORY,
  APPS,
  SECURITY,
  WEBAPP_JSON,
  ORG_JSON,
  STAFF,
  DANGER,
}

export const Settings: FunctionComponent = () => {
  const { t } = useTranslation();
  const { t: ctxT } = useTranslation('', { keyPrefix: 'orgDashboardSettings' });

  const { isStaff } = useContext(UserContext).userProfile;

  const isNarrowViewport = useIsNarrowViewport();

  const [selectedTabIndex, setSelectedTabIndex] = useState(SettingsTabType.GENERAL);

  const tabItems: TabItem[] = useMemo(
    () => [
      { index: SettingsTabType.GENERAL, name: ctxT('general'), content: <General /> },
      { index: SettingsTabType.TAGS, name: ctxT('tags'), content: <Tags /> },
      { index: SettingsTabType.CATEGORY, name: ctxT('category'), content: <Templates /> },
      { index: SettingsTabType.SECURITY, name: ctxT('security'), content: <Security /> },
      ...optArrItem(isStaff, {
        index: SettingsTabType.WEBAPP_JSON,
        name: ctxT('webapp-json'),
        content: <AppConfig />,
      }),
      ...optArrItem(isStaff, {
        index: SettingsTabType.ORG_JSON,
        name: ctxT('org-json'),
        content: <OrgConfig />,
      }),
      ...optArrItem(isStaff, {
        index: SettingsTabType.STAFF,
        name: ctxT('staff'),
        content: <Staff />,
      }),
      ...optArrItem(isStaff, {
        index: SettingsTabType.DANGER,
        name: ctxT('danger'),
        content: <Danger />,
      }),
    ],
    [ctxT, isStaff]
  );

  return (
    <div className={classes['settings']}>
      <h1 className={classes['settings__title']}>{t('orgLayoutMenu.settings')}</h1>
      <Tabs
        items={tabItems}
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
        {...(isStaff && { tabNamesItemClassName: classes['settings__tab-names-item'] })}
        scrollable={isNarrowViewport}
        noBackground
      />
    </div>
  );
};
